/**
 *@Author  ahuan
 *@Description
 *@Date 2024/6/25
 **/
import mqtt from "@/assets/js/mqtt";
import load from "@/common/load";
import singleDev from "@/stores/singleDev";

export default {
    hostName: "beefindtech.com", // 地址
    protocol: "wss", // 协议
    port: 18084, // 端口
    endPoint: "/mqtt", // 后缀
    options: {  // 配置参数
        keepalive: 0, // 心跳时间
        clientId: 'beefind_' + Math.random().toString(16).substr(2, 8),
        protocolId: 'MQTT',
        protocolVersion: 4,
        clean: true, //设置为 false 以在离线时接收 QoS 1 和 2 消息
        reconnectPeriod: 1000, // 两次重新连接的间隔。设置为 可禁用自动重新连接0
        connectTimeout: 30 * 1000, // 连接超时时间
        username: "",
        password: "",
    },
    subscription: {  // 订阅主题
        topic: "/mqttshell-return/", // 默认
        qos: 0,
    },
    publish: {
        topic: "/mqttshell/", // 默认发布
        qos: 0,
        payload: ""
    },
    retryTimes: 0, //重连次数
    client: {
        connected: false,  // 连接状态
    },
    deliverTheMessage: null,// 回传信息的方法
    subscribeSuccess: false, // 判断当前有无订阅主题
    initData() { // 初始化参数
        console.log("初始化MQTT数据---");
        this.client = {
            connected: false,
        };
        this.retryTimes = 15;
        this.subscribeSuccess = false;
    },
    handleOnReConnect() { //MQTT重连函数
        this.retryTimes += 1
        if (this.retryTimes > 5) {
            try {
                this.client.end()
                this.initData()
            } catch (error) {
                console.error(error.toString())
            }
        }
    },
    MqttConnection(f) {
        console.log("MQTT开始连接");
        try {
            let {hostName, protocol, port, endPoint, options} = this;
            let connectionUrl = `${protocol}://${hostName}:${port}${endPoint}`;
            this.client = mqtt.connect(connectionUrl, options);
            if (this.client.on) {
                this.client.on("connect", () => {
                    console.log("MQTT连接成功--");
                    if (f) {
                        f()
                        f = null;
                    }
                });
                this.client.on("message", (topic, message) => {
                    if (message.toString() !== 'command running...') {
                        this.deliverTheMessage(topic, message.toString());
                    }
                    console.log(`Received message ${message} from topic ${topic}`);
                });
                // 重连方法
                this.client.on("reconnect", this.handleOnReConnect);
                this.client.on("error", (error) => {
                    console.log("MQTT错误吗", error)
                    console.log(this.client.connected)
                    load.error("MQTT连接失败,错误码--", error);
                });
            }
        } catch (e) {
            load.error("MQTT连接异常...");
        }
    },
    doSubscribe(type = true) { // 订阅主题
        let {topic, qos} = this.subscription
        if (type) {
            let single = singleDev();
            topic += single.currentCode.qrCode;
        }
        this.client.subscribe(topic, {qos}, (error, res) => {
            if (error) {
                console.log('订阅主题失败--', error)
                return
            }
            this.subscribeSuccess = true;
            console.log('订阅主题成功--', res)
        })
    },
    doUnSubscribe() { // 取消订阅
        let {topic} = this.subscription
        this.client.unsubscribe(topic, error => {
            if (error) {
                console.log('取消订阅失败,失败码--', error)
            }
        })

    },
    doPublish(type =true) { // 消息发布
        let {topic, qos, payload} = this.publish
        console.log("send:=>", payload)
        if(type){
            let single = singleDev();
            topic += single.currentCode.qrCode;
        }
        this.client.publish(topic, payload, {qos}, error => {
            if (error) {
                console.log('Publish error', error)
            }
        })
    },
    destroyConnection() { // 断开连接
        if (this.client.connected) {
            try {
                this.client.end(false, () => {
                    this.initData()
                    console.log('断开MQTT连接成功(手动)--')
                })
            } catch (error) {
                console.log('断开MQTT连接失败(手动)--', error.toString())
            }
        }
    }

}
